<template>
  <div class='tableWithPerPageSelection'>
    <error-msg-component :messages="messages"
                          :error="error"
                          :title="'editionClient.problemOccurred'"
                          :withEmplyFields="true"
                          :messagesChampsVide="messagesChampsVide"
                          :champsVide="champsVide"
                          @close="error = $event"/>
    <a ref="lienDownload"></a>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class='columns'>
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="getAllCommandeSelected().length > 0"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()" class='column is-narrow pdr-0'>
            <b-input
              :placeholder="$t('renouvellementCommande.actions.search')"
              type='search'
              icon='magnify'
              v-model='critereRecherche.auto'
            ></b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('renouvellementCommande.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <exportExcelButton
          :perm="permCommandes.exporter"
          :query="exportExcelQuery"
          :secondaryExports="secondaryActions"/>
        <parametrage-table class="mgl-10px"
          :reference-table="referenceTable"
          @endLoadParamtre="arrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <montant-total-par-etat :filtres="filtresSave"
                            v-if="filtresSave"
                            ref="montantTotalParEtat">
    </montant-total-par-etat>
    <a ref="lienDownload"></a>
    <v-server-table
      :columns="columns"
      :options="options"
      v-if="arrayRendering && finChargement"
      @loaded="finLoading"
      @loading="debutLoading"
      :ref="referenceTable"
      class="overflow-x-auto"
    >
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input='$refs[referenceTable].setLimit($event)' />
      </template>
      <template slot='appendBody'>
        <table-footer-totaux
          ref="tableTotaux"
          :columns="columns"
          :target="targetTotal"
          :items="commandes">
        </table-footer-totaux>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected">
        </b-checkbox>
      </div>
      <div slot="etatRenouvellement" slot-scope="props" class="columns">
        <b-icon v-if="props.row.etatRenouvellement"
          class="column is-narrow"
          icon="circle"
          size="is-small"
          :type="getColorRound(props.row.etatRenouvellement)"
        >
        </b-icon>
        <div class="column">
          <router-link-blank v-if="isRenouvelerOrTacite(props.row.etatRenouvellement)
          && props.row.historique[0] && props.row.historique[0].id !== props.row.id"
                             :to="{ name: 'c.bodac.commandes',
                             params: { id: getIdCommande(props.row) } }"
                             :message="$t(getEtat(props.row.etatRenouvellement))">
          </router-link-blank>
          <div v-else>
            {{$t(getEtat(props.row.etatRenouvellement))}}
          </div>
        </div>
      </div>
      <div slot="code" slot-scope="props">
        <section class="is-flex is-justify-content-space-between">
          <router-link-blank :to="{ name: 'c.bodac.commandes', params: {id: props.row.id}}"
                            :message="props.row.code">
          </router-link-blank>
          <tag-list
                class="mgl-2 is-justify-content-flex-end"
                v-if="getListeTags(props.row)"
                :listes="getListeTags(props.row)"/>
        </section>
      </div>
      <div slot="commercial" slot-scope="props" v-if="props.row.commercial">
        {{ getNomPrenom(props.row.commercial) }}
      </div>
      <div slot="payeur" slot-scope="props">
        <router-link-blank
          v-for="(payeur, index) in props.row.listePayeurs"
          :key="index"
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: payeur.tiersId }}"
          :message="payeur.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="annonceur" slot-scope="props">
        <router-link-blank
          v-for="(annonceur, index) in props.row.listeAnnonceurs"
          :key="index"
          :to="{ name: 'c.bodac.clients/contacts-client',
          params: { id: annonceur.tiersId }}"
          :message="annonceur.nomCommercial">
        </router-link-blank>
      </div>
      <div slot="montantHt" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="dateRenouvellement" slot-scope="props">
        {{ props.row.dateRenouvellement | formatDate }}
      </div>
      <div slot="datePreavis" slot-scope="props">
        {{ props.row.datePreavis | formatDate }}
      </div>
      <div slot="commentaireInterne" slot-scope="props" >
        <commentaireListInput
          :id="props.row.id"
          v-model="props.row.commentaireInterne"
          :maj="majCom">
        </commentaireListInput>
      </div>
      <div slot="dateDemandeDeRenouvellement" slot-scope="props">
        {{ props.row.dateDemandeDeRenouvellement | formatDate }}
      </div>
      <div slot="agence" slot-scope="props">
        {{ getAgenceLibelle(props.row.agenceId) }}
      </div>
      <div slot="editer" slot-scope="props"
           class="has-text-centered">
        <btn-action-icon
          :tooltip-label="$t('general.button.edition')"
          :permission="permCommandes.editer"
          @is-click="edition({format: 'Pdf', typeDonnee: constantes.TYPE_EDITION_COMMANDE},
            props.row.id)"
          icon="file-pdf-box">
        </btn-action-icon>
      </div>
      <div slot="actions" class="has-text-centered" slot-scope="props">
        <b-dropdown
          position="is-bottom-left"
          aria-role="list"
          class="has-text-left">
          <a slot="trigger">
            <b-icon
              icon="dots-vertical"
              type="is-default"
            >
            </b-icon>
          </a>
          <b-dropdown-item v-if="props.row.etatRenouvellement === etatArenouveler
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS"
            @click="checkPermissions(permCommandes.maj)
          ? renouveler(props.row) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.renouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item v-if="props.row.etatRenouvellement === etatArenouveler
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS"
            @click="checkPermissions(permCommandes.maj)
          ? marquerRenouveleReconduit([props.row.id], etatRenouvelee) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.marquerRenouvele')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item @click="checkPermissions(permCommandes.maj)
          ? changeEtatEnAttente(props.row.id) : showPopUp()"
                           v-if="props.row.etatRenouvellement === etatRenouvelee
                        || props.row.etatRenouvellement === etatNonRenouvelee
                        || props.row.etatRenouvellement === etatTacite
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.aRenouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item @click="checkPermissions(permCommandes.maj)
          ? ajoutCommentaireNonRenouvellement([props.row.id]) : showPopUp()"
                           v-if="props.row.etatRenouvellement === etatArenouveler
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.pasRenouveler')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.reconductible && (props.row.etatRenouvellement === etatArenouveler
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS)"
            @click="checkPermissions(permCommandes.maj)
          ? $router.push({ name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
        params: { id: props.row.id, renouveleOrTacite: etatTacite } }) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.reconduireTacitement')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item
            v-if="props.row.reconductible && (props.row.etatRenouvellement === etatArenouveler
                        || props.row.etatRenouvellement === constantes.ETAT_ENCOURS)"
            @click="checkPermissions(permCommandes.maj)
          ? marquerRenouveleReconduit([props.row.id], etatTacite) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.marquerReconduitTacitement')}}
            </p>
          </b-dropdown-item>
          <b-dropdown-item v-if="props.row.etatRenouvellement === constantes.ETAT_ENCOURS
              || props.row.etatRenouvellement === etatArenouveler"
                           @click="checkPermissions(permCommandes.maj)
          ? enCoursRenouvellement([props.row.id]) : showPopUp()">
            <p class="is-default is-size-6">
              {{ $t('renouvellementCommande.actions.enCours')}}
            </p>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-renouvellement-commande
                    v-if="finChargement"
                    ref="filtreRenouvellementCommande"
                    @toggleFiltre="setShowFiltre"
                    @recherche="makeRechercheFilter()"/>
    </div>
    <b-modal v-model="popUpMotifNonRenouvellement" has-modal-card class="modal">
      <pop-up-motif-non-renouvellement @motifNonRenouvellement="ajoutCommentaireNonRenouvellement"
                                       :commande-ids="commandeMotifNonRenouvellementIds"
                                       @recherche="recherche"
      ></pop-up-motif-non-renouvellement>
    </b-modal>
    <b-modal v-model="popUpErrorChangeEtat" width="500px">
      <pop-up-erreur :mess-header="messageHeader"
                     :mess-footer="messageFooter"
                     :messages="codeCmdNotChange">
      </pop-up-erreur>
    </b-modal>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import * as devisConf from '@/configuration/devisConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import {
  retourEnAttente,
  enCoursRenouvellement,
  renouvellementReconduction as renouvellementReconductionCmd,
  commenter,
} from '@/api/commande/index';
import * as renouvellementReconduction from '@/services/bodac/commande/renouvellementReconduction/renouvellementReconduction';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import { COMMANDES } from '@/configuration/permissionsBodacConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import filtreRenouvellementCommande from '@/components/devisCommandes/filtreRenouvellementCommande';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import montantTotalParEtat from '@/components/commande/renouvellement/montantTotalParEtat';
import selecteurAction from '@/components/general/selecteurAction';
import {
  ACTION_EN_COURS_RENOUVELLEMENT, ACTION_MARQUER_RENOUVELEE,
  ACTION_MARQUER_RECONDUIT_TACITEMENT, TYPE_EDITION_COMMANDE, ACTION_MARQUER_NE_PAS_RENOUVELER,
} from '@/configuration/commande/commandeConf';
import popUpErreur from '@/components/general/popUpErreur';
import PopUpMotifNonRenouvellement from '@/components/commande/renouvellement/popUpMotifNonRenouvellement';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import edition from '@/api/edition';
import tagList from '@/components/general/tagList';
import validationGeneral from '@/services/validation/validation';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import validationLignesCommande from '@/services/dcf/validation/validationVentePartielle';
import translate from '@/services/devisCommandes/validation/champsCommandeTranslator';
import { columnsSplice } from '@/services/general/columns';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import tableFooterTotaux from '@/components/general/tableFooterTotaux';
import { REFERENCE_TABLE_RENOUVELLEMENT_COMMANDES } from '@/configuration/general/referenceTableConf';
import parametrageTable from '@/components/general/parametrageTable';
import updateCritereWithParametreInterne from '@/services/dcf/updateCritereWithParametreInterne';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import genererCriteresRechercheRenouvellementCommande
  from '@/services/commande/criteresRecherche/genererCriteresRechercheRenouvellementCommande';
import { SET_CRITERE } from '@/store/modules/renouvellementCommande-mutation-type';
import BtnActionIcon from '@/components/general/btnActionIcon';
import exportExcelButton from '@/components/general/button/exportExcelButton';

const renouvellementCommande = createNamespacedHelpers('renouvellementCommande');
const permissions = createNamespacedHelpers('permissions');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    BtnActionIcon,
    PopUpMotifNonRenouvellement,
    routerLinkBlank,
    filtreRenouvellementCommande,
    TableItemsInView,
    montantTotalParEtat,
    selecteurAction,
    popUpErreur,
    errorMsgComponent,
    tableFooterTotaux,
    parametrageTable,
    commentaireListInput,
    exportExcelButton,
    tagList,
  },
  data() {
    return {
      showFiltre: false,
      etatArenouveler: devisConf.ETAT_ENATTENTE,
      etatNonRenouvelee: devisConf.ETAT_NONRENOUVELEE,
      etatRenouvelee: devisConf.ETAT_RENOUVELEE,
      etatTacite: devisConf.ETAT_TACITE,
      permCommandes: COMMANDES,
      unsubscribeValue: null,
      sens: devisConf.SENS_VENTE,
      arrayRendering: false,
      constantes: {
        ETAT_ENCOURS: devisConf.ETAT_ENCOURS,
        TYPE_EDITION_COMMANDE: TYPE_EDITION_COMMANDE,
      },
      codeCmdNotChange: [],
      popUpMotifNonRenouvellement: false,
      commandeMotifNonRenouvellementIds: [],
      actions: [
        { action: ACTION_EN_COURS_RENOUVELLEMENT, translation: 'renouvellementCommande.actions.marquerEnCoursRenouvellement' },
        { action: ACTION_MARQUER_RENOUVELEE, translation: 'renouvellementCommande.actions.marquerRenouvele' },
        { action: ACTION_MARQUER_RECONDUIT_TACITEMENT, translation: 'renouvellementCommande.actions.marquerReconduitTacitement' },
        { action: ACTION_MARQUER_NE_PAS_RENOUVELER, translation: 'renouvellementCommande.actions.marquerPasRenouveler' },
      ],
      finChargement: false,
      filtresSave: null,
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
      popUpErrorChangeEtat: false,
      messageHeader: null,
      messageFooter: null,
      referenceTable: REFERENCE_TABLE_RENOUVELLEMENT_COMMANDES,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
        PARAMETRES_INTERNE_KEYS.medialinePlanningLCRenouvellement.key,
      ]);
      this.setCritereRecheche(genererCriteresRechercheRenouvellementCommande(
        this.medialinePlanningLCRenouvellement));
      this.critereRecherche.agencesId = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      if (this.$route.params.sens) {
        this.sens = this.$route.params.sens;
      }
      await updateCritereWithParametreInterne(this.critereRecherche);
      this.setInformationPage(this.$t('pageGescom.commande.listeCommandeARenouveler'));
      this.finChargement = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  computed: {
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
      agencesSelectionnees: 'agenceActive',
      societeActive: 'societeActive',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...renouvellementCommande.mapGetters({
      critereRecherche: 'criteresRecherche',
      commandes: 'renouvellementCommande',
      totalRenouvellement: 'totalRenouvellementCommande',
      lastDataFromLoad: 'lastDataFromLoad',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    nombreCritere() {
      const banCritere = ['auto', 'sens', 'societeId', 'date', 'etat', 'dates', 'optionDate', 'dateCampagne'];
      if (this.societeActive.agences.length === 1) banCritere.push('agencesIds');
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritere);
      if (this.critereRecherche.dateCampagne.dateDebut
         || this.critereRecherche.dateCampagne.dateFin) {
        nbCritere += 1;
      }
      if ((this.critereRecherche.dates.dateDebut
        || this.critereRecherche.dates.dateFin)
        && this.critereRecherche.optionDate) nbCritere += 1;
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    targetTotal() {
      return ['montantHt'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          etatRenouvellement: this.$i18n.t('renouvellementCommande.table.etat'),
          code: this.$i18n.t('renouvellementCommande.table.numeroCommande'),
          codeDossier: this.$i18n.t('renouvellementCommande.table.codeDossier'),
          commercial: this.$i18n.t('renouvellementCommande.table.commercial'),
          payeur: this.$i18n.t('renouvellementCommande.table.payeur'),
          annonceur: this.$i18n.t('renouvellementCommande.table.annonceur'),
          montantHt: this.$i18n.t('renouvellementCommande.table.montantHt'),
          dateRenouvellement: this.$i18n.t('renouvellementCommande.table.dateRenouvellement'),
          datePreavis: this.$i18n.t('renouvellementCommande.table.datePreavis'),
          actions: this.$i18n.t('renouvellementCommande.table.actions'),
          motifNonRenouvellement: this.$i18n.t('renouvellementCommande.table.motifNonRenouvellement'),
          dateDemandeDeRenouvellement: this.$i18n.t('renouvellementCommande.table.dateDemande'),
          commentaireInterne: this.$i18n.t('listeCommandes.table.commentaireInterne'),
          agence: this.$i18n.t('renouvellementCommande.table.agence'),
          editer: '',
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        sortable: ['etatRenouvellement', 'code', 'codeDossier', 'commercial', 'payeur', 'annonceur', 'montantHt', 'dateRenouvellement', 'datePreavis', 'dateDemandeDeRenouvellement', 'motifNonRenouvellement'],
        columnsClasses: {
          annonceurs: 'ellipsis colonneListeIntervenants',
          payeurs: 'ellipsis colonneListeIntervenants',
          actions: 'colonneSelected',
          selected: 'colonneSelected',
        },
        requestFunction: ((data) => {
          if (data.orderBy === undefined) {
            data.orderBy = this.critereRecherche.orderBy;
            data.ascending = this.critereRecherche.ascending;
          }
          if (this.critereRecherche.agencesId.length === 0) {
            this.critereRecherche.agencesId = this.agencesSelectionnees
              .map((agence) => agence.agenceId);
          }
          data.query = cloneDeep(this.critereRecherche);
          if (data.query.groupeIds.length > 0) {
            data.query.groupeIds = data.query.groupeIds.map((groupe) => { return groupe.id; });
          }
          if (data.query.enseigneIds.length > 0) {
            data.query.enseigneIds = data.query.enseigneIds.map((enseigne) => {
              return enseigne.id;
            });
          }
          if (data.query.payeurs.length > 0) {
            data.query.payeurs = data.query.payeurs.map((payeur) => {
              return payeur.id;
            });
          }
          if (data.query.annonceurs.length > 0) {
            data.query.annonceurs = data.query.annonceurs.map((annonceur) => {
              return annonceur.id;
            });
          }
          data.query.tagIds = data.query.tagIds.map(t => t.id);
          data.query.societeId = this.societeActiveId;
          data.query.sens = this.sens;
          this.filtresSave = cloneDeep(data);
          return this.loadCommandes(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.commandes,
            count: this.totalRenouvellement,
          };
        }),
      };
    },
    columns() {
      const columns = ['selected', 'etatRenouvellement', 'code', 'codeDossier', 'commercial', 'payeur', 'annonceur', 'montantHt', 'dateRenouvellement', 'datePreavis', 'dateDemandeDeRenouvellement', 'motifNonRenouvellement', 'agence', 'commentaireInterne', 'editer', 'actions'];
      if (this.societeActive.agences.length === 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    allCommandeSelected() {
      return this.getAllCommandeSelected().length === this.commandes.length;
    },
    iconSelectTotal() {
      if (this.allCommandeSelected) return 'checkbox-multiple-marked-outline';
      return 'checkbox-multiple-blank-outline';
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key);
    },
    medialinePlanningLCRenouvellement() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.medialinePlanningLCRenouvellement.key);
    },
    exportExcelQuery() {
      return {
        typeDonnee: 'commande',
        typeExport: 'VYPARenouveler',
        filtres: this.lastDataFromLoad,
      };
    },
    secondaryActions() {
      return [
        {
          libelle: this.$t('renouvellementCommande.actions.exportColonne'),
          query: {
            typeDonnee: 'commande',
            typeExport: 'AAARenouveler',
            filtres: this.lastDataFromLoad,
          },
        },
      ];
    },
  },
  methods: {
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...renouvellementCommande.mapMutations({
      setCritereRecheche: SET_CRITERE,
    }),
    getListeTags(row) {
      if (!row?.tags || row.tags.length === 0) return null;
      return row?.tags?.map(t => t.tag) ?? [];
    },
    updateAgenceAndRecherche() {
      this.critereRecherche.agencesId = this.agencesSelectionnees
        .map((agence) => agence.agenceId);
      this.recherche();
    },
    async edition(donnees, id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: [id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
          parametresAdditionnels: donnees.parametresAdditionnels,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    getAgenceLibelle(agenceId) {
      const agenceActiveFind = this.agencesSelectionnees.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceActiveFind) return agenceActiveFind.libelleAgence;
      return '';
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRenouvellementCommande.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    getNomPrenom(user) {
      return nomPrenomGetter(user);
    },
    getAllCommandeSelected() {
      return this.commandes.filter((type) => { return type.selected; });
    },
    selectAll() {
      const select = !this.allCommandeSelected;
      this.commandes.forEach((el) => { el.selected = select; });
    },
    async enCoursRenouvellement(ids) {
      const loadingComponent = this.$buefy.loading.open();
      const params = {
        devisCommandeIds: ids,
      };
      try {
        await enCoursRenouvellement(params);
        loadingComponent.close();
        messageSucces(ids.length > 1
          ? this.$i18n.t('renouvellementCommande.messages.success.changeEtatEnCoursMultiCommande')
          : this.$i18n.t('renouvellementCommande.messages.success.changeEtatEnCours'));
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async marquerRenouveleReconduit(ids, etatRenouvellement) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const message = await renouvellementReconduction
          .marquerCommandeRenouveleeReconduite(ids, etatRenouvellement);
        loadingComponent.close();
        messageSucces(message);
        this.recherche();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    async recherche() {
      await this.$refs[this.referenceTable].refresh();
      await this.$refs.montantTotalParEtat.updateTotaux();
    },
    ajoutCommentaireNonRenouvellement(commandeIds) {
      this.popUpMotifNonRenouvellement = true;
      this.commandeMotifNonRenouvellementIds = commandeIds;
    },
    async changeEtatEnAttente(id) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await retourEnAttente(id);
        loadingComponent.close();
        messageSucces(this.$t('renouvellementCommande.changeEtatSucess'));
        this.recherche();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
      }
    },
    ...renouvellementCommande.mapActions({
      loadCommandes: 'loadRenouvellementCommandes',
    }),
    getEtat(etatCommande) {
      const etatRenouvellementFind = devisConf.LISTE_ETAT_RENOUVELLEMENT
        .find((etatRenouvellement) => {
          return etatRenouvellement.code === etatCommande;
        });
      return etatRenouvellementFind ? etatRenouvellementFind.libelle : '';
    },
    getColorRound(etatRenouvellement) {
      switch (etatRenouvellement) {
        case devisConf.ETAT_ENATTENTE:
          return 'is-aRenouveler';
        case devisConf.ETAT_TACITE:
          return 'is-tacite';
        case devisConf.ETAT_NONRENOUVELEE:
          return 'is-nonRenouvelee';
        case devisConf.ETAT_ENCOURS:
          return 'is-enCours';
        default:
          return 'is-primary';
      }
    },
    isRenouvelerOrTacite(etat) {
      return (etat === devisConf.ETAT_RENOUVELEE || etat === devisConf.ETAT_TACITE);
    },
    getIdCommande(actualCommande) {
      const index = actualCommande.historique.findIndex((historique) => {
        return historique.id === actualCommande.id;
      });
      return actualCommande.historique.length > 0 ? actualCommande.historique[index - 1].id : '';
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    checkCommandeToEnCours() {
      if (this.getAllCommandeSelected().every((cmd) => {
        return cmd.etatRenouvellement === devisConf.ETAT_ENCOURS
          || cmd.etatRenouvellement === devisConf.ETAT_ENATTENTE;
      })) {
        this.enCoursRenouvellement(this.getAllCommandeSelected().map(cmd => { return cmd.id; }));
        return;
      }
      this.codeCmdNotChange = this.getAllCommandeSelected()
        .filter(cmd => {
          return cmd.etatRenouvellement !== devisConf.ETAT_ENCOURS
            && cmd.etatRenouvellement !== devisConf.ETAT_ENATTENTE;
        })
        .map(cmd => { return { libelle: cmd.code }; });
      this.popUpErrorChangeEtat = true;
      this.messageHeader = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatEnCours');
      this.messageFooter = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatEnCoursDes');
    },
    ouvrirPopUpMotifNePasRenouveler() {
      if (this.getAllCommandeSelected().every((cmd) => {
        return cmd.etatRenouvellement === devisConf.ETAT_ENCOURS
          || cmd.etatRenouvellement === devisConf.ETAT_ENATTENTE;
      })) {
        this.ajoutCommentaireNonRenouvellement(
          this.getAllCommandeSelected().map(cmd => { return cmd.id; }),
        );
        return;
      }
      this.codeCmdNotChange = this.getAllCommandeSelected()
        .filter(cmd => {
          return cmd.etatRenouvellement !== devisConf.ETAT_ENCOURS
            && cmd.etatRenouvellement !== devisConf.ETAT_ENATTENTE;
        })
        .map(cmd => { return { libelle: cmd.code }; });
      this.popUpErrorChangeEtat = true;
      this.messageHeader = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatNePasRenouveler');
      this.messageFooter = this.$t('renouvellementCommande.messages.error.badEtatForChangeEtatNePasRenouvelerDes');
    },
    async checkCommandeToMarquerRenouveleReconduit(etatRenouvellement) {
      const retour = await renouvellementReconduction.marquerListeCommandeRenouveleeReconduite(
        this.getAllCommandeSelected(), etatRenouvellement,
      );
      this.codeCmdNotChange = retour.codeCmdNotChange;
      this.popUpErrorChangeEtat = retour.popUpErrorChangeEtat;
      this.messageHeader = retour.messageHeader;
      this.messageFooter = retour.messageFooter;
      if (retour.success) this.recherche();
    },
    handleAction(action) {
      if (action === ACTION_EN_COURS_RENOUVELLEMENT) this.checkCommandeToEnCours();
      else if (action === ACTION_MARQUER_RENOUVELEE) {
        this.checkCommandeToMarquerRenouveleReconduit(this.etatRenouvelee);
      } else if (action === ACTION_MARQUER_RECONDUIT_TACITEMENT) {
        this.checkCommandeToMarquerRenouveleReconduit(this.etatTacite);
      } else if (action === ACTION_MARQUER_NE_PAS_RENOUVELER) {
        this.ouvrirPopUpMotifNePasRenouveler();
      }
    },
    async renouveler(commande) {
      if (commande === undefined || commande === null) return;
      this.error = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await renouvellementReconductionCmd(commande.id, this.etatRenouvelee);
        loadingComponent.close();
        this.$router.push({
          name: 'm.bodac.commandes-ajoutRenouvelOrTacite',
          params: { id: commande.id, renouveleOrTacite: this.etatRenouvelee },
        });
      } catch (e) {
        loadingComponent.close();
        this.error = true;
        validationDevisCommande(e.response,
          this.messages,
          this.isNewDevisCommande,
          devisConf.TYPE_COMMANDE);
        await validationLignesCommande(e.response, this.messages, this.nouveauDevisCommande);
        validationGeneral(this.$i18n, e.response, this.champsVide,
          this.messages, this.messagesChampsVide, translate);
        throw e;
      }
    },
    async reinitialiser() {
      await this.$refs.filtreRenouvellementCommande.initializeFiltre();
      await this.$refs.filtreRenouvellementCommande.viderCritere();
      this.$refs.filtreRenouvellementCommande.appliquerCritere();
      this.showFiltre = false;
    },
    majCom(id, commentaire) {
      return commenter({ id, commentaire });
    },
  },
};
</script>
